// Polyfills
import "core-js/stable";
import "regenerator-runtime/runtime";
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
Vue.prototype.$axios = axios;
import App from "./App";
import { ColorThemePlugin } from "../services/vuestic-ui";
import store from "../store/index";
import router from "../router/index";
import { VuesticPlugin } from "../services/vuestic-ui/components";

import YmapPlugin from "vue-yandex-maps";
import VueClipboard from "vue-clipboard2";

import Vuelidate from "vuelidate";
import Vue2Filters from "vue2-filters";

import "../metrics";
import "../registerServiceWorker";

import { consoleBuildInfo } from "vue-cli-plugin-build-info/plugin";

//alert sweetalert2
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';

import "@/assets/css/custom.css"

import ax from "axios";
export const axios = ax;
import VueAxios from "vue-axios";

consoleBuildInfo();

Vue.use(VuesticPlugin);
Vue.use(YmapPlugin);
Vue.use(VueClipboard);
Vue.use(Vue2Filters);
Vue.use(VueSweetalert2);

Vue.use(ColorThemePlugin, {
    // override colors here.
});

Vue.use(Vuelidate);

Vue.use(VueAxios, axios);

/// set global store...
/// each page loading...
router.beforeEach((to, from, next) => {
    next();
});

router.afterEach((to, from) => {
});

/* eslint-disable no-new */
new Vue({
    el: "#app",
    router,
    store,
    render: h => h(App)
});